import AttachmentFullViewState from '../schema/AttachmentFullViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('setActionCompletePercent')(function setActionCompletePercent(
    attachment: AttachmentFullViewState,
    completePercent: number
) {
    attachment.actionCompletePercent = completePercent;
});
